export function formatPathUrl(path: string) {
  return `/submitted-documents/${path
    .split("/")
    .slice(2, undefined)
    .map(encodeURIComponent)
    .join("/")}`;
}

export function decodePathFromUrl(path: string | undefined) {
  return path?.split("/").map(decodeURIComponent).join("/");
}
